import {
  Copy,
  Heading,
  Image,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import {
  statesContent,
  supportEmail,
} from 'src/components/selfService/features/Signup/steps/ValidationStep/constants';

export function ApprovedWithoutNetTermsState(): JSX.Element {
  const { approvedWithoutNetTerms } = statesContent;

  const { isPhone } = useScreenSizes();
  const textAlign = isPhone ? 'left' : 'center';

  return (
    <>
      <Stack y="sm" alignSelf="center">
        <Image
          width="250px"
          src={approvedWithoutNetTerms.illustrationUrl}
          alt=""
          role="presentation"
        />
      </Stack>
      <Stack y="sm">
        <Heading variant="h1" textAlign={textAlign}>
          {approvedWithoutNetTerms.title}
        </Heading>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {approvedWithoutNetTerms.text[0]}
        </Copy>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {approvedWithoutNetTerms.text[1]}{' '}
          <Link variant="muted" href={`mailto:${supportEmail}`}>
            {supportEmail}
          </Link>
        </Copy>
      </Stack>
    </>
  );
}
